<template>
  <b-modal v-if="isShow" :active.sync="isShow" :can-cancel="false" :width="446">
    <div class="box is-boxed-3">
      <div class="columns is-dektop is-mobile is-vcentered">
        <div class="column is-12 has-text-centered">
          <p class="font-20 font-w-600 has-text-darkblue">Batalkan Pembelian?</p>
          <p class="font-16 font-w-400 has-text-darkblue" style="margin-top: 24px;">
            Transaksi yang Anda batalkan akan tetap tercatat pada daftar Pembelian Kelas.
          </p>
        </div>
      </div>
      <div class="columns is-dektop is-mobile is-vcentered">
        <div class="column is-6">
          <button class="button is-text is-medium is-fullwidth has-background-greystroke has-text-primary2" 
            style="border-radius: 6px;"
            :disabled="loading_cancel"
            @click.prevent="close">
            <span class="font-16 font-w-500">Tidak</span>
          </button>
        </div>
        <div class="column is-6">
          <button class="button is-danger is-medium font-w-500 is-fullwidth" 
            style="border-radius: 6px;"
            :class="{'is-loading': loading_cancel}"
            :disabled="loading_cancel"
            @click.prevent="cancelOrder(edlorderId)">
            <span class="font-16 font-w-600">Ya, batalkan</span>
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import EDLODER_MIXINS from '~/mixins/edlorder'

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    edlorderId: {
      type: Number,
      default: null,
    },
    onCancelProcessSuccess: {
      type: Function,
      default: () => {}
    },
  },

  mixins: [EDLODER_MIXINS],

  methods: {
    close() {
      this.onClose()
    },

    onCancelOrderSuccess() {
      this.close()
      this.onCancelProcessSuccess()
    }
  }
}
</script>
